import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import ProfileConfigurationDto = Cloud.RavenDB.Core.Dto.Profile.ProfileConfigurationDto;
import UpdatePhoneNumberDto = Cloud.RavenDB.Core.Dto.Profile.UpdatePhoneNumberDto;

export default class ProfileService extends AbstractService {
    getConfiguration = async (): Promise<ProfileConfigurationDto> => {
        const configuration = await this.query<ProfileConfigurationDto>(ApiRoutes.profile.getConfiguration());

        return configuration.data;
    };

    updatePhoneNumber = async (dto: UpdatePhoneNumberDto): Promise<void> => {
        await this.post<UpdatePhoneNumberDto, void>(ApiRoutes.profile.updatePhoneNumber(), dto);
    };
}
